angular.module('unergie.main')
.filter('governmentPriceReductionType', () =>
    function (val) {
        switch (val) {
            case 'collective-tariff-shield':
                return 'Bouclier tarifaire collectif'
            case 'tariff-shield':
                return 'Bouclier tarifaire'
            case 'shock-absorber':
                return 'Amortisseur électricité'
            default:
                return val
        }
    },
)
